import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { summaryRows } from '../data/summary';
export function SummaryTable() {
  return <section className="py-16 sm:py-20" aria-labelledby="summary-title" data-id="element-179" data-mp="o606ydatvopg">
      <div className="mx-auto max-w-4xl px-4" data-id="element-180" data-mp="o4713081h8ii">
        <SectionHeading id="summary-title" data-id="element-181" data-mp="j7yfb3zc6h2d">Tutto ciò che è <span className="text-orange-400" data-id="element-182" data-mp="j53v9dk8iy9h">incluso:</span></SectionHeading>

        <ul className="mt-10 grid overflow-hidden rounded-2xl border border-slate-800 bg-slate-900 sm:grid-cols-2" data-id="element-183" data-mp="1guf8py4y8aiu">
          {summaryRows.map(feature => <li key={feature} className="flex items-start gap-3 border-b border-slate-800 p-4 sm:odd:border-r" data-id="element-184" data-mp="16wrfjcmzrb2s">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-amber-400" data-id="element-185" data-mp="12vpaugab26tf">
                <CheckIcon className="h-3.5 w-3.5 text-slate-950" aria-hidden="true" data-id="element-186" data-mp="3ro1l146w1vo2" />
              </span>
              <b className="text-sm text-white" data-id="element-187" data-mp="3nkc2owgt4abh">{feature}</b>
            </li>)}
        </ul>
      </div>
    </section>;
}